module.exports = __webpack_public_path__ + "img/car-img.dc579447.png";